import React, { Component, ChangeEvent } from 'react';
import { RouteComponentProps } from 'react-router';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap'
import ConfigurationStore from '../stores/ConfigurationStore';
import { AllStores } from '../stores';
import { OrganizationFields } from '../components/OrganizationFields';
import { required, isAlpha, isEmail, isAlphanumeric } from '../utils/ValidatorRulesUtils';
import OrganizationStore from '../stores/OrganizationStore';

type OrganizationProps = {
    organizationStore : OrganizationStore;
    configurationStore : ConfigurationStore;
}

@inject((allStores: AllStores) => {
    return {
        organizationStore : allStores.organizationStore as OrganizationStore,
        configurationStore : allStores.configurationStore as ConfigurationStore
    };
})
@observer
class Organization extends Component<OrganizationProps & RouteComponentProps> {

    componentDidMount() {
        const params : any = this.props.match.params;
        const organizationId = parseInt(params.organizationId);
        this.props.organizationStore.setCurrentOrganization(organizationId);
    }

    updateName = (event : ChangeEvent<EventTarget>) => {
        const target = event.target as HTMLInputElement;
        this.setState({ name: target.value });
    };

    render() {
        const { configurationStore, organizationStore } = this.props;
        const { currentOrganization: org, updateOrganization } = organizationStore;
        
        return (
            <div>
                <h1>Organizations - {org && org.name}</h1>
                <Link to={'/organization/'} className="mr-5">
                    <Glyphicon glyph="arrow-left" /> All Organizations
                </Link>
                <hr></hr>
                <OrganizationFields buttonText='Submit' onSubmit={updateOrganization} initialState={org} configurationStore={configurationStore} organizationStore={organizationStore} 
                />
            </div>
        );
    }
}


export { Organization };